import styled from "styled-components";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { SpinnerLoading } from "@/main/components/shared/styles";

export const AccordionContactStyle = styled(Accordion)`
	&&& {
		background: ${({ theme }) => theme.grayLight};
		padding: 0.6rem 0;
		margin: 0 0 1rem;

		/* When is Expanded */
		&.MuiAccordion-root.Mui-expanded {
			margin: 0 0 1rem;
		}

		.MuiSvgIcon-root {
			color: ${({ theme }) => theme.pantone2727C};
		}
	}
`;
export const AccordionSummaryContact = styled(AccordionSummary)`
	&&& {
		background: ${({ theme }) => theme.grayLight};
	}
`;
export const AccordionTitle = styled.h5`
	&&& {
		font-weight: bold;
		margin: 0;
	}
`;

export const AccordionDetailsContacts = styled(AccordionDetails)`
	&&& {
		display: flex;
		flex-direction: column;
		background: ${({ theme }) => theme.grayLight};
		overflow-y: auto;
		padding: 0 8px;

		${SpinnerLoading} {
			margin: 0.4rem auto;
		}
	}
`;

export const ContentContacts = styled.div`
	display: flex;
	flex-direction: column;
`;
